// utils/userPayload.js

/**
 * Sanitizes user update payloads before sending them to the backend.
 *
 * Responsibilities:
 * - Removes empty strings ('')
 * - Removes empty arrays ([])
 */

export const sanitizeUserUpdate = (payload) => {
  const clean = { ...payload };

  Object.keys(clean).forEach((key) => {
    const value = clean[key];

    if (value === '') delete clean[key];
    if (Array.isArray(value) && value.length === 0) delete clean[key];
  });

  // ❌ ja NO hi ha cap conversió estranya
  return clean;
};